// pages/Discount/AllMedicinesDiscount.js
import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import Breadcrumb from "components/Common/Breadcrumb";
import DashboardLoader from "components/Loader/DashboardLoader";
import { companyApiService } from "services/companyApiService";

const AllMedicinesDiscount = () => {
  const [companyData, setCompanyData] = useState(null);
  console.log("companyData", companyData);

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [discountValue, setDiscountValue] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  // Fetch company discount data
  const fetchCompanyDiscount = async () => {
    setLoading(true);
    try {
      const data = await companyApiService.getCompanyDiscount();
      setCompanyData(data);
      setDiscountValue(data.medicinediscount || "");
    } catch (error) {
      toast.error("Failed to fetch discount data");
      console.error("Error fetching company discount:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyDiscount();
  }, []);

  // Handle update discount
  const handleUpdateDiscount = async () => {
    if (!discountValue.trim()) {
      toast.error("Please enter a discount value");
      return;
    }

    // Validate discount value (should be a number between 0-100)
    const discountNum = parseFloat(discountValue);
    if (isNaN(discountNum) || discountNum < 0 || discountNum > 100) {
      toast.error("Discount must be a number between 0 and 100");
      return;
    }

    setUpdating(true);
    try {
      await companyApiService.updateMedicineDiscount(discountValue);
      toast.success("Medicine discount updated successfully");

      // Update local state
      setCompanyData(prev => ({
        ...prev,
        medicinediscount: discountValue
      }));

      setIsEditing(false);
    } catch (error) {
      toast.error("Failed to update discount");
      console.error("Error updating medicine discount:", error);
    } finally {
      setUpdating(false);
    }
  };

  // Handle edit button click
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setDiscountValue(companyData?.medicinediscount || "");
    setIsEditing(false);
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <DashboardLoader />;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb title="Discount" breadcrumbItem="Medicine Discount" />

        <div className="row justify-content-center">
          <div className="col-lg-5">
            <div className="card">
              {/* <div className="card-header">
                <h4 className="card-title mb-0">
                  <i className="fas fa-percentage me-2"></i>
                  Medicine Discount Settings
                </h4>
              </div> */}
              <div className="card-body">
                {companyData && (
                  <div className="row">

                    <div className="col-md-12">
                      <div className="mb-4">
                        <h5 className="text-muted mb-3">Update Medicine Discount</h5>

                        <div className="alert alert-info">
                          <i className="fas fa-info-circle me-2"></i>
                          This discount will apply to all medicines in the system.
                        </div>

                        <div className="mb-4">
                          {isEditing ? (
                            <>
                              <label className="form-label fw-semibold">Medicine Discount (%)</label>
                              <div className="input-group">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={discountValue}
                                  onChange={(e) => setDiscountValue(e.target.value)}
                                  min="0"
                                  max="100"
                                  step="0.5"
                                  placeholder="Enter discount percentage"
                                />
                                <span className="input-group-text">%</span>
                              </div>
                              <small className="form-text text-muted">
                                Enter a value between 0 and 100
                              </small>
                            </>
                          ) : (
                            <div className="text-center p-4 border rounded bg-light">
                              <h1 className="display-4 text-primary mb-0">
                                {companyData.medicinediscount || "0"}%
                              </h1>
                              <p className="text-muted mt-2">Current Medicine Discount</p>
                            </div>
                          )}
                        </div>

                        <div className="d-flex gap-2">
                          {isEditing ? (
                            <>
                              <button
                                className="btn btn-success"
                                onClick={handleUpdateDiscount}
                                disabled={updating}
                              >
                                {updating ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Updating...
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-check me-2"></i>
                                    Save Changes
                                  </>
                                )}
                              </button>
                              <button
                                className="btn btn-light"
                                onClick={handleCancelEdit}
                                disabled={updating}
                              >
                                <i className="fas fa-times me-2"></i>
                                Cancel
                              </button>
                            </>
                          ) : (
                            <button
                              className="btn btn-primary"
                              onClick={handleEditClick}
                            >
                              <i className="fas fa-edit me-2"></i>
                              Edit Discount
                            </button>
                          )}

                          <button
                            className="btn btn-secondary"
                            onClick={fetchCompanyDiscount}
                            disabled={loading || updating}
                          >
                            <i className="fas fa-sync-alt me-2"></i>
                            Refresh
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}


              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default AllMedicinesDiscount;